import React from "react";
import { Box, Container, Paper } from "@mui/material";

import { Button } from "../Button";

interface IProps {
  disabled?: boolean;
  onSaveLabel?: string;

  onCancel?(): void;
  onGoBack?(): void;
  onSaveAndNew?(): void;
  onSave(): Promise<void> | void;
}

export const Footer: React.FC<IProps> = ({
  onSave,
  onGoBack,
  onCancel,
  onSaveAndNew,
  disabled = false,
  onSaveLabel = "Salvar",
}) => {
  return (
    <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 99 }}>
      <Paper elevation={4}>
        <Container>
          <Box
            sx={{
              height: "65px",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {onCancel && (
              <Box>
                <Button
                  fullWidth
                  size="large"
                  label="Cancelar"
                  variant="outlined"
                  onClick={onCancel}
                />
              </Box>
            )}

            {onGoBack && (
              <Box ml={2}>
                <Button
                  fullWidth
                  size="large"
                  label="Voltar"
                  onClick={onGoBack}
                  disabled={disabled}
                />
              </Box>
            )}

            <Box ml={2}>
              <Button
                fullWidth
                size="large"
                onClick={onSave}
                disabled={disabled}
                label={onSaveAndNew ? "Salvar e Voltar" : onSaveLabel}
              />
            </Box>

            {onSaveAndNew && (
              <Box ml={2}>
                <Button
                  fullWidth
                  size="large"
                  disabled={disabled}
                  label="Salvar e Novo"
                  onClick={onSaveAndNew}
                />
              </Box>
            )}
          </Box>
        </Container>
      </Paper>
    </Box>
  );
};
